import { CURRENCY } from "application/constants/app-constants";
import getCountry from "./getCountry";
import { find, keys } from "ramda";

export default function getCurrency() {
  const country = getCountry();
  const countryKeys = keys(CURRENCY);
  const region = find((k) => k === country, countryKeys);
  if (region) return CURRENCY[region];

  return CURRENCY["gb"];
}
